import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomizedBlockPage } from '../../models';
import { SLICE_NAMES } from '../constants';

export const customizedBlockPageInitialState: CustomizedBlockPage = {
  backgroundURL: '',
  backgroundImageInByte: '',
  isCustomizedText: false,
  titleText: '',
  subtitleText: '',
  textColor: 'white',
};

const customizedBlockPageSlice = createSlice({
  name: SLICE_NAMES.CUSTOMIZED_BLOCK_PAGE,
  initialState: customizedBlockPageInitialState,
  reducers: {
    setCustomizedBlockPage: (
      state: CustomizedBlockPage,
      action: PayloadAction<Partial<CustomizedBlockPage>>
    ) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setCustomizedBlockPage } = customizedBlockPageSlice.actions;

export const customizedBlockPageReducer = customizedBlockPageSlice.reducer;
